import { render, staticRenderFns } from "./GameControls.vue?vue&type=template&id=17eeb6e3&scoped=true&"
import script from "./GameControls.vue?vue&type=script&lang=js&"
export * from "./GameControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eeb6e3",
  null
  
)

export default component.exports